export default {"src":"/login-app/[GIT_HASH]/_next/static/media/waterfall_chart.be12af4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};